export const CLINIC = {
  name: "Muse Charitable Dental Clinic",
  area: "Burari, Delhi",
  phoneDisplay: "+91 88001 77172",
  phoneDial: "918800177172",
  email: "drnarinderjha@gmail.com",
  hours: "Mon–Tue, Thu–Sun · 9:30 AM–2:00 PM & 4:00 PM–8:30 PM · Closed Wednesday",
  rating: "5.0",
  reviews: 58,
  tagline: "Understand your dental health",
};

export const PRIORITY = {
  urgent: { label: "Act Soon", color: "#D9381E", bg: "#FCEBE8", text: "#9E2A16" },
  attention: { label: "Needs Attention", color: "#E67300", bg: "#FDF0E3", text: "#8A4A08" },
  consider: { label: "Consider", color: "#2E8540", bg: "#E6F2EA", text: "#1E5C2C" },
};

export const DISCLAIMER =
  "This is an AI-assisted screening and educational tool. It is NOT a confirmed diagnosis. Always consult a dentist before making any decision, and get a professional assessment for a final diagnosis.";

export const VIEWS = [
  {
    key: "upper_occlusal",
    title: "Upper Occlusal",
    instruction: "Biting surface of your upper teeth.",
    steps: ["Tilt your head back", "Open wide", "Hold the phone above, pointing down"],
  },
  {
    key: "lower_occlusal",
    title: "Lower Occlusal",
    instruction: "Biting surface of your lower teeth.",
    steps: ["Tilt your head forward", "Pull your lower lip down", "Point down at your lower teeth"],
  },
  {
    key: "frontal",
    title: "Frontal",
    instruction: "Front teeth and gums.",
    steps: ["Bite your teeth together", "Smile to show front teeth & gums", "Keep the phone level"],
  },
  {
    key: "right_lateral",
    title: "Right Lateral",
    instruction: "Right-side teeth.",
    steps: ["Bite together", "Pull your right cheek back", "Aim at your right teeth"],
  },
  {
    key: "left_lateral",
    title: "Left Lateral",
    instruction: "Left-side teeth.",
    steps: ["Bite together", "Pull your left cheek back", "Aim at your left teeth"],
  },
  {
    key: "problem_area",
    title: "Problem Area",
    instruction: "The exact tooth or gum that bothers you.",
    steps: ["Aim at the exact tooth/gum", "Hold about 5–10 cm away", "Make sure there is good light"],
  },
];

export const SUBSCORE_LABELS = {
  sharpness: "Sharpness",
  exposure: "Exposure",
  glare: "Glare",
  visibility: "Visibility",
  framing: "Framing",
};

export const COMMON_QUESTIONS = [
  { label: "Tooth pain", q: "I have tooth pain. What could be causing it and what should I do?" },
  { label: "Sensitivity", q: "My teeth feel sensitive to hot and cold. Why does this happen?" },
  { label: "Bleeding gums", q: "My gums bleed when I brush. Is that something to worry about?" },
  { label: "Bad breath", q: "What causes bad breath and how can I prevent it?" },
  { label: "Swelling", q: "I have swelling in my gum or face. What should I do?" },
  { label: "Broken tooth", q: "I chipped or broke a tooth. What are my options?" },
  { label: "Mouth ulcer", q: "I have a mouth ulcer that won't heal. Should I be worried?" },
  { label: "Whitening", q: "How can I whiten my teeth safely?" },
];
